// Decorative graphic on the empty-cart / subscribed heroes: a hexagon of black
// dots on a triangular lattice (rows of 4-5-6-7-6-5-4). Values from the Figma
// export.
const DOT_HEX_ROWS = [
    [3, 5, 7, 9],
    [2, 4, 6, 8, 10],
    [1, 3, 5, 7, 9, 11],
    [0, 2, 4, 6, 8, 10, 12],
    [1, 3, 5, 7, 9, 11],
    [2, 4, 6, 8, 10],
    [3, 5, 7, 9],
];
const DOT_COL = 4.87; // horizontal step between lattice columns
const DOT_ROW = 8.35; // vertical step between rows
const DOT_R = 2.78; // dot radius

// `dot` = rendered diameter of one dot in px (default ~14). The SVG is scaled
// so a viewBox dot (diameter 2·DOT_R) renders at that size.
export function DotHexagon({ dot = 14, className = '' }: { dot?: number; className?: string }) {
    const scale = dot / (DOT_R * 2);
    return (
        <svg
            width={64 * scale}
            height={56 * scale}
            viewBox="0 0 64 56"
            className={`flex-none ${className}`}
            aria-hidden
        >
            {DOT_HEX_ROWS.flatMap((cols, r) =>
                cols.map((c) => (
                    <circle
                        key={`${r}-${c}`}
                        cx={c * DOT_COL + DOT_R}
                        cy={r * DOT_ROW + DOT_R}
                        r={DOT_R}
                        fill="#000000"
                    />
                )),
            )}
        </svg>
    );
}

export default DotHexagon;
